import React from 'react';

import H2 from 'apps/Pdf/components/common/H2';

import { sqlDateToLabel, formatAmount } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { CashMovementsData } from '../StatementInterface';
import { AmountValue } from 'common/interfaces';
import { Currency, AccountMode } from 'enums';

interface Props {
  from: string;
  to: string;
  data: CashMovementsData[];
  currency: Currency;
  total: AmountValue;
  mode: AccountMode;
}

enum movementType {
  'CASH_DEPOSIT' = 'Vklad hotovosti',
  'CASH_EMPLOYER' = 'Vklad hotovosti',
  'CASH_WITHDRAWAL' = 'Výběr hotovosti',
  'SECURITY_DEPOSIT' = 'Vklad cenných papírů',
  'SECURITY_WITHDRAWAL' = 'Výběr cenných papírů',
}

const CashMovementsTable = (props: Props) => {
  const styles = useGeneralStyles();
  const tables = useTableStyles();
  const { data, total } = props;

  return (
    <>
      {data.length ? (
        <>
          <H2>
            Pohyby hotovosti v období {sqlDateToLabel(props.from, 'd. M. yyyy')}&#8202;—&#8202;
            {sqlDateToLabel(props.to, 'd. M. yyyy')}
          </H2>

          <table className={`${tables.root} ${tables.overview}`}>
            <thead>
              <tr>
                <th>Datum</th>
                <th>Pohyb</th>
                <th>Hodnota</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`${item.date}`}>
                  <td>{sqlDateToLabel(item.date, 'd. M. yyyy')}</td>
                  <td className={styles.value}>
                    {movementType[item.type]}
                    {props.mode === AccountMode.LTIP && item.type === 'CASH_DEPOSIT' && ' (klient)'}
                    {props.mode === AccountMode.LTIP && item.type === 'CASH_EMPLOYER' && ' (zaměstnavatel)'}
                    {item.isin && ` – ${item.isin}`}
                  </td>
                  <td className={styles.value}>{formatAmount(item.value, item.value.currency)}</td>
                </tr>
              ))}
              {total && (
                <tr className="sum">
                  <td colSpan={2} className={styles.value}>
                    Celkem
                  </td>
                  <td className={styles.value}>{formatAmount(total, props.currency)}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  );
};

export default CashMovementsTable;
